<template>
  <v-card elevation="0" class="pa-4" width="100%">
    <div class="d-flex align-center bar ml-3">
      <v-btn @click="close" icon class="secondary-button bar ma-1" depressed>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-btn @click="print" icon class="secondary-button bar ma-1" depressed>
        <v-icon>mdi-printer</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <strong class="mr-2 bar hidden-sm-and-down">Itens por linha:</strong>
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="secondary-button bar hidden-sm-and-down"
            depressed
            icon
          >
            {{ qtd }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(size, i) in sizes" :key="i" @click="qtd = size">
            <v-list-item-title>{{ size }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-row class="ma-0" justify="center">
      <v-col
        v-for="equip in equipmentList"
        :key="equip.id"
        cols="11"
        :sm="cols"
        :md="cols"
      >
        <v-card
          outlined
          class="pa-4 text-center d-flex flex-column align-center"
          height="100%"
          :width="cols >= 3 ? '100%' : '180px'"
          style="break-inside: avoid"
        >
          <img
            class="mt-4 mb-2"
            :src="
              logo
                ? logo
                : institution && institution.logoPath
                ? institution.logoPath
                : require('../../../../assets/01_-_Reduzido_Cor.png')
            "
            alt="Equipacare"
            style="width: 6rem; border-radius: 8px"
          />
          <Qrcode :value="`${value}${equip.id}`" :size="cols * 35"></Qrcode>
          <strong class="text-center" style="font-size: 1.2rem">
            <span v-if="layout.usingIdentificationLayout"
              >{{ formatIdText(equip.identification) }}
            </span>
            <span v-else>{{ equip.propertyCode }}</span>
          </strong>
        </v-card>
      </v-col>
    </v-row>

    <!-- <v-row class="ma-0" style="place-content: center" id="printer">
      <v-col
        cols="11"
        sm="4"
        md="4"
        lg="2"
        v-for="equip in equipmentList"
        :key="equip.id"
        class="tag"
      >
        <div class="d-flex justify-center align-center flex-column">
          <img
            class="mt-4 mb-2"
            :src="
              logo
                ? logo
                : institution && institution.logoPath
                ? institution.logoPath
                : require('../../../../assets/01_-_Reduzido_Cor.png')
            "
            alt="Equipacare"
            style="width: 6rem; border-radius: 8px"
          />
          <Qrcode :value="`${value}${equip.id}`" :size="100"></Qrcode>
          <p class="pa-0 ma-0 text-center" style="font-size: 1.2rem">
            <strong v-if="layout.usingIdentificationLayout">{{
              formatIdText(equip.identification)
            }}</strong>
            <strong v-else>{{ equip.propertyCode }}</strong>
          </p>
        </div>
      </v-col>
    </v-row> -->
  </v-card>
</template>

<script>
import Vue from 'vue'
import ApiService from '../../../../services/ApiService'
import Qrcode from 'qrcode.vue'

export default {
  props: {
    filter: Object,
  },

  components: {
    Qrcode,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    Vue.$globalEvent.$emit('loader', true)

    try {
      const promises = [this.loadInstitutionLayout()]

      if (this.filter) {
        promises.push(this.getEquipment())
      }

      await Promise.all(promises)
      await this.waitForQrCodesRender()
    } finally {
      Vue.$globalEvent.$emit('loader', false)
    }
  },

  data: () => ({
    institution: {},
    value: `${window.location.origin}/aboutEquipment/`,
    equipmentList: [],
    apiService: new ApiService(),
    logo: '',
    layout: {
      logo: '',
      usingIdentificationLayout: true,
      idLayout: {
        showFullName: true,
      },
    },
    headMenu: null,
    loading: false,
    cols: 2,
    sizes: [2, 3, 4, 6],
    qtd: 6,
  }),

  watch: {
    qtd() {
      switch (this.qtd) {
        case 2:
          this.cols = 6
          break

        case 3:
          this.cols = 4
          break

        case 4:
          this.cols = 3
          break

        case 6:
          this.cols = 2
          break

        default:
          break
      }
    },
  },

  methods: {
    async loadInstitutionLayout() {
      const response = await this.apiService.get(
        `institution/${this.institution.id}`,
        null,
        true,
        false
      )

      this.institution = response.content

      if (this.institution.qrCodeTagCustomization) {
        const parsedLayout = JSON.parse(this.institution.qrCodeTagCustomization)
        this.layout = this.convertPascalToCamel(parsedLayout)
      }

      this.logo = this.layout.logo
    },

    convertPascalToCamel(obj) {
      if (obj === null || typeof obj !== 'object') return obj
      
      if (Array.isArray(obj)) {
        return obj.map(item => this.convertPascalToCamel(item))
      }
      
      const newObj = {}
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const camelKey = key.charAt(0).toLowerCase() + key.slice(1)
          newObj[camelKey] = this.convertPascalToCamel(obj[key])
        }
      }
      return newObj
    },

    print() {
      window.print()
    },

    formatIdText(text) {
      if (this.layout.idLayout.showFullName) {
        return text
      }
      return text.split('-')[0]
    },

    showPropertyCode() {
      this.layout.usingIdentificationLayout = false
    },

    showIdentification() {
      this.layout.usingIdentificationLayout = true
    },

    async getEquipment() {
      this.equipmentList = []
      await this.apiService
        .post('equipment/list', this.filter, null, true, false)
        .then((response) => {
          this.equipmentList = response.content.equipment
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async waitForQrCodesRender() {
      if (!this.equipmentList.length) {
        return
      }

      await this.$nextTick()

      const maxAttempts = 30
      let attempts = 0

      while (attempts < maxAttempts) {
        await new Promise((resolve) => requestAnimationFrame(resolve))

        const qrCodesRendered = this.$el.querySelectorAll('canvas, svg').length
        if (qrCodesRendered >= this.equipmentList.length) {
          return
        }

        attempts += 1
      }
    },

    close() {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>
@media print {
  .bar {
    display: none;
    height: 0;
    width: 0;
  }
}

.tag {
  display: flex;
  border: 1px solid black;
  margin: 10px;
  padding: 5px;
  padding-top: 0;
  justify-content: center;
}

@media print {
  header {
    display: none;
  }

  .tag {
    max-width: 40% !important;
  }

  .row {
    margin-top: 5rem;
  }
}
</style>
